import React from 'react'
import { Navigate } from 'react-router-dom'

const Configuration = () => {
    return <Navigate to="/configuration/cars" replace />
}

export default Configuration